import { Link } from 'react-router-dom';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 dark:from-gray-900 dark:to-gray-800">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-primary-600 to-primary-700 dark:from-primary-800 dark:to-primary-900 text-white py-20 lg:py-28">
        <div className="absolute inset-0 bg-black/10"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
              Keep track of your Forms with
              <span className="block text-yellow-300"> Professional Excellence</span>
            </h1>
            
            <p className="text-xl md:text-2xl mb-8 text-blue-100 max-w-3xl mx-auto leading-relaxed">
              Get Organised high-quality Leads; organised through analytics and a clean dashboard
            </p>



            {/* CTA Scroll Indicator */}
            <div className="animate-bounce">
              <div className="text-blue-200 text-sm font-semibold mb-2">GET YOUR QUOTE NOW</div>
              <div className="text-2xl">👇</div>
            </div>
          </div>
        </div>
      </section>


      {/* Process Section */}
      <section className="py-16 bg-gray-50 dark:bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">
              The Process
            </h2>
            <p className="text-xl text-gray-600 dark:text-gray-400">
              Simple process from Form creation to Tracking analytics
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {[
              { step: '1',  title: 'Submit form', desc: 'Fill out our detailed project inquiry' },
              { step: '2',  title: 'Check Dashboard', desc: 'Ensure correct information' },
              { step: '3', title: 'Check Analytics', desc: 'Discuss project details & quotas' },
              { step: '4',  title: 'Project Start', desc: 'We begin work on your Project' }
            ].map((process, index) => (
              <div key={index} className="text-center relative">
                {/* Connecting Line */}
                {index < 3 && (
                  <div className="hidden md:block absolute top-8 left-1/2 w-full h-0.5 bg-primary-200 dark:bg-primary-800 z-0"></div>
                )}
                
                <div className="relative z-10 bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-lg border border-gray-200 dark:border-gray-700">
                  <div className="w-12 h-12 bg-primary-500 rounded-full flex items-center justify-center text-white font-bold text-lg mx-auto mb-4">
                    {process.step}
                  </div>
                  <div className="text-3xl mb-4">{process.icon}</div>
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                    {process.title}
                  </h3>
                  <p className="text-gray-600 dark:text-gray-400 text-sm">
                    {process.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Final CTA */}
      <section className="py-16 bg-gradient-to-r from-primary-600 to-primary-700 dark:from-primary-800 dark:to-primary-900 text-white">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Ready to Get Started?
          </h2>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
            Manage your leads efficiently with our comprehensive dashboard
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/analytics"
              className="bg-white text-primary-600 hover:bg-gray-100 px-8 py-4 rounded-lg font-semibold text-lg transition-colors duration-200 flex items-center justify-center gap-2"
            >
              📊 View Analytics
            </Link>
            <Link 
              to="/dashboard"
              className="border-2 border-white text-white hover:bg-white hover:text-primary-600 px-8 py-4 rounded-lg font-semibold text-lg transition-colors duration-200 inline-flex items-center justify-center gap-2"
            >
              📋 Manage Leads
            </Link>
            <Link 
              to="/form"
              className="bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors duration-200 inline-flex items-center justify-center gap-2"
            >
              ➕ Create Lead
            </Link>
          </div>
        </div>
      </section>
      </div>
  );
};

export default LandingPage;